var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "chat-message", class: _vm.direction },
    [
      _c("img", {
        staticClass: "message-avatar",
        attrs: { src: _vm.message.sender_image, alt: "" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "message", class: { deleted: _vm.deleted } }, [
        _c("span", { staticClass: "message-author" }, [
          _vm.$checkUserIsAdmin(_vm.message.user)
            ? _c(
                "span",
                [
                  _vm.$vlastMode
                    ? [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.message.user.name) +
                            " (Admin)\n        "
                        ),
                      ]
                    : [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.clientName) +
                            " Admin -  " +
                            _vm._s(_vm.message.user.first_name) +
                            "\n        "
                        ),
                      ],
                ],
                2
              )
            : _c("span", [_vm._v(_vm._s(_vm.message.user.name))]),
          _vm._v(" "),
          _vm.message.user.role === "manager"
            ? _c("span", [_vm._v(" - Manager")])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("span", { staticClass: "message-date" }, [
          _vm._v(_vm._s(_vm.messageLocalTime)),
        ]),
        _vm._v(" "),
        _vm.message.text
          ? _c("span", { staticClass: "message-content" }, [
              _vm._v(_vm._s(_vm.message.text.trim())),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.message.type === "file"
          ? _c("div", [
              _vm.message.file
                ? _c("span", { staticClass: "message-filename" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("truncateFilename")(
                          _vm.message.file.file_name,
                          20
                        )
                      )
                    ),
                  ])
                : _c("span", [_vm._v("File Deleted")]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "actions" }, [
          _vm.$userIsAdmin
            ? _c("span", { staticClass: "message-sub pull-right" }, [
                !this.message.deleted_at
                  ? _c("i", {
                      staticClass: "fa fa-trash",
                      attrs: { title: "Delete Message" },
                      on: { click: _vm.handleDeleteMessageCallback },
                    })
                  : _vm.message.type !== "file"
                  ? _c("i", {
                      staticClass: "fa fa-refresh",
                      attrs: { title: "Restore Message" },
                      on: { click: _vm.handleRestoreMessageCallback },
                    })
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.message.type === "file" && _vm.message.file
            ? _c(
                "span",
                {
                  staticClass: "message-download",
                  on: { click: this.handleDownloadFileCallback },
                },
                [
                  _c("i", { staticClass: "fa fa-cloud-download" }),
                  _vm._v(" Download File\n      "),
                ]
              )
            : _vm.message.user_id === this.$user.id
            ? _c("div", { staticClass: "pull-left" }, [
                this.message.loading
                  ? _c("span", { staticClass: "pull-right message-sub" }, [
                      _vm._v("Sending"),
                      _c("span", { staticClass: "loader" }),
                    ])
                  : _c("span", { staticClass: "pull-right message-sub" }, [
                      _vm._v("Sent"),
                    ]),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm._l(_vm.readers, function (reader) {
        return _c(
          "span",
          { key: reader.id },
          [
            _c("img", {
              staticClass: "message-avatar pull-right",
              staticStyle: { width: "20px" },
              attrs: {
                src: reader.profile_image_url,
                alt: "",
                id: "reader" + reader.id,
              },
            }),
            _vm._v(" "),
            _c("tooltip", {
              attrs: {
                text: _vm.readerName(reader),
                target: "#reader" + reader.id,
              },
            }),
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.readers.length
        ? _c(
            "span",
            {
              staticClass: "pull-right",
              staticStyle: { color: "grey", "font-size": "12px" },
            },
            [_vm._v("Seen by ")]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }